import { NotFound } from "@totalsoft/rocket-webapp-components-deprecated";
import React, { useEffect } from "react";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";
import PrivateRoute from "./routing/PrivateRoute";
import { AUTH } from "providers/AuthenticationProvider";
import PublicMain from "./layout/PublicMain";
import PublicContractualDocuments from "features/public/components/content/PublicContractualDocuments";
import PublicDataCompletion from "features/public/components/content/PublicDataCompletion";
import { Loader } from "./layout/ApplicationLoader";
import PublicGdprConsent from "features/public/components/content/PublicGdprConsent";

const PageNotFound = () => <NotFound title="PageNotFound"></NotFound>;

const DelayedRouteRedirect = () => {
  const history = useHistory();

  useEffect(() => {
    setTimeout(() => history.push({ pathname: `/` }), 3500);
  }, [history]);

  return <Loader />;
};

const PublicApp = () => {
  return (
    <Switch>
      <Route exact path="/" component={PublicMain} />
      <Route exact path="/redirect" component={DelayedRouteRedirect} />
      <Route exact path="/public/data-completion" component={PublicDataCompletion} />
      <Route exact path="/public/contractual-documents" component={PublicContractualDocuments} />
      <Route exact path="/public/gdpr-consent" component={PublicGdprConsent} />
      <PrivateRoute exact path="/login" component={PageNotFound} />
      <Redirect exact from={`${AUTH.LOGOUT_REDIRECT}`} to="/" />
      <Redirect exact to="/redirect" />
    </Switch>
  );
};

export default PublicApp;
